// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__rrflh","container":"style_container__p_dRa","links":"style_links__OFqWf","link":"style_link__CdiPM"};